import axios from 'axios'
import {ISelectOption} from '../../../utils/core/_model'
import {BASE_URL} from '../../config'
import toast from 'react-hot-toast'
import {handleAxiosError} from '../../../utils/helperFunction/_helper'

const GET_USR_ATTACHEMTN_BY_ID = `${BASE_URL}/api/protect/getUserAllAttachments?userId=`

export const setUserType = (user_profile: number) => {
  let type: string = ''

  if (user_profile === 1) {
    type = 'Admin'
  } else if (user_profile === 2) {
    type = 'Reseller'
  } else if (!user_profile) {
    type = 'Unknown'
  } else {
    type = 'Client'
  }

  return type
}

export const getValueName = (arrValue: ISelectOption[], id: string): string => {
  let value_name = ''
  const selected = arrValue.find((vl) => vl.id === parseInt(id))

  if (selected) {
    value_name = selected.label
  }

  return value_name
}

export const getUserAttachment = async (userid: number) => {
  try {
    const response = await axios.get<{
      usernid: string
      userprofile: string
      usertradelicense: string
    }>(`${GET_USR_ATTACHEMTN_BY_ID}${userid}`)
    const data = await response.data

    return data
  } catch (error) {
    toast.dismiss()
    const message = handleAxiosError(error)
    toast.error(message)
    console.log(error)
  }
}
